import { forwardRef, useState } from 'react'

import { clsx } from 'clsx'
import { useClipboard } from 'use-clipboard-copy'

import { Input } from '../Input/Input.js'
import { Link } from '../Link/index.js'
import { FormControlInputProps } from './FormControlInput.js'
import { FormControlLayout } from './FormControlLayout.js'
import { extractLayoutProps } from './utils.js'

export type FormControlInputCopyProps = FormControlInputProps & {
  hideValue?: boolean
  controlLabels?: {
    show?: string
    hide?: string
    copy?: string
    copied?: string
  }
}

export const FormControlInputCopy = forwardRef<
  HTMLInputElement,
  FormControlInputCopyProps
>((props, ref) => {
  const { value, hideValue = false, controlLabels = {}, ...rest } = props
  const { layoutProps, inputProps } = extractLayoutProps(rest)

  const {
    show: showLabel = 'Show',
    hide: hideLabel = 'Hide',
    copy: copyLabel = 'Copy',
    copied: copiedLabel = 'Copied',
  } = controlLabels

  const [copied, setCopied] = useState(false)
  const clipboard = useClipboard()

  const [showValue, setShowValue] = useState(!hideValue)

  const addon = hideValue ? (
    <div className="flex items-center h-full pe-2">
      <Link onClick={() => setShowValue(!showValue)} variant="neutral">
        {showValue ? hideLabel : showLabel}
      </Link>
    </div>
  ) : null

  return (
    <FormControlLayout {...layoutProps}>
      <Input
        ref={ref}
        {...inputProps}
        value={value}
        onClick={e => e.currentTarget.select()}
        type={showValue ? 'text' : 'password'}
        trailingAddon={
          <div className="flex h-full divide-x divide-line-subdued">
            {addon}
            <div
              className={clsx('flex items-center h-full', !!addon && 'ps-2')}
            >
              <Link
                onClick={() => {
                  clipboard.copy(value)
                  setCopied(true)
                  setTimeout(() => setCopied(false), 2000)
                }}
                variant="neutral"
              >
                {copied ? copiedLabel : copyLabel}
              </Link>
            </div>
          </div>
        }
      />
    </FormControlLayout>
  )
})
